module.exports = __webpack_public_path__ + "img/Frame-73.d85f6136.svg";